import $ from "jquery";
import config from '../../config.json';
import auth from '../../auth/auth.react.js';
import React from 'react';
import {
  Card,
  CardHeader,
  CardText
} from 'material-ui/Card';
import {
  Redirect
} from 'react-router-dom'
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import Joi from 'joi';
import validation from 'react-validation-mixin';
import strategy from 'joi-validation-strategy';
import CSSModules from 'react-css-modules';
import styles from './all.css';

const create_url = config.server + config.api_path + '/employee/clients'

class AddClientView extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      msg: null,
      redirect: null,
      client_email: '',
      name: '',
    }

    this.validatorTypes = {
      client_email: Joi.string()
        .required()
        .email()
        .label('Email'),
      name: Joi.string()
        .required()
        .min(1)
        .max(50)
        .label('Client Name')
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  handleChange(e) {
    const target = e.target;
    var value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleBlur(e) {
    const target = e.target;
    var value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
        [name]: value
      },
      this.props.handleValidation(name)
    )
  }

  onSubmit(e) {
    e.preventDefault()
    this.props.validate((err) => {
      if (err) return
      $.post({
          dataType: 'json',
          url: create_url,
          contentType: 'application/json',
          data: auth.with_session({
            email: this.state.client_email,
            name: this.state.name,
          }),
          xhrFields: {
            withCredentials: true
          }
        })
        .done((data) => {
          var _err = data.err
          if (_err && _err.ec === 0) {
            this.setState({
              redirect: '/clients/all'
            })
          } else if (_err && _err.dm === 'not_in') {
            this.props.unauthorized()
          } else if (_err) {
            this.setState({
              msg: _err.em
            })
          }
        })
    })
  }

  getValidatorData() {
    return this.state
  }

  renderHelperText(msg) {
    var err_msg = msg
    if (Array.isArray(msg) && msg.length > 0) {
      err_msg = msg[0]
    }
    return (
      <span styleName="">{err_msg}</span>
    )
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={{pathname: this.state.redirect}} />
    }
    return (
      <Card styleName="cli-card">
        <CardHeader
          title="Add Client"
          subtitle={this.state.msg}
          actAsExpander={false}
          showExpandableButton={false}
      />
      <CardText>
        <TextField
          floatingLabelText="Client Email"
          floatingLabelFixed={true}
          name="client_email"
          value={this.state.client_email}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          errorText={this.renderHelperText(this.props.getValidationMessages('client_email'))} />
        <br />
        <TextField
          floatingLabelText="Client Name"
          floatingLabelFixed={true}
          name="name"
          value={this.state.name}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          errorText={this.renderHelperText(this.props.getValidationMessages('name'))} />
        <br />
        <RaisedButton backgroundColor="#3ed5ad" labelColor="#ffffff" label={"Add Client " + this.state.name} onClick={this.onSubmit} disabled={!this.props.isValid()} />
      </CardText>
      </Card>
    )
  }
}

export default validation(strategy)(CSSModules(AddClientView, styles))



// WEBPACK FOOTER //
// ./src/views/clients/new.react.js